import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Auth gate WITHOUT the main AppLayout chrome — used by self-contained products
// like the Promotion Center that provide their own layout.
export default function RequireAuth() {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="font-mono text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  return <Outlet />;
}
